module.exports = __webpack_public_path__ + "img/down-triangle-pointer.3e14dee4.svg";